import React, { createContext, useState } from 'react';
import { Silver } from 'react-dial-knob';
import styled from 'styled-components';

import EventContext, { DefaultEventContext } from '../../context/EventContext';
import { M3SR_DIM, MenuButtonSize } from '../../Dimentions';
import BlackButton from '../common/BlackButton';
import Console, { MenuItem } from '../common/Console';
import DoubleButton from '../common/DoubleButton';
import MenuTouchableButton, { MenuDirection } from '../common/MenuTouchableButton';
import MenuJson from './MockMenu.json';

const CompContainer = styled.div`
  width: ${M3SR_DIM.width}px;
  height: ${M3SR_DIM.height}px;
  background: rgba(255, 255, 255, 1);
  display: flex;
`;

const ConsoleContainer = styled.div`
  width: 75%;
  height: 100%;
  background: rgba(90, 106, 134, 1);
  padding: 15px;
`;

const DialPadContainer = styled.div`
  width: 25%;
  height: 100%;
  background: rgba(213, 213, 213, 1);
  padding: 15px;
`;

const DialPad = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 5px;
  row-gap: 5px;
  margin-top: 40px;
  margin-left: 40px;
  margin-right: 40px;
  place-items: center;
`;

const NumberBox = styled.div`
  background: rgba(63, 63, 63, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  border-radius: 20%;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const KnobContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ButtonPanelContianer = styled.div`
  display: grid;
  grid-template-columns: 200px auto 200px;
  width: 100%;
  height: 20%;
  margin-top: 5px;
`;
const LeftButtonContainer = styled.div`
  grid-template-columns: 1fr 1fr 1fr;
  display: grid;
  column-gap: 5px;
`;
const MiddleButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
`;
const RightButtonContainer = styled.div`
  grid-template-columns: 1fr 1fr 1fr;
  display: grid;
  column-gap: 5px;
`;

const TopPanel = styled.div`
  width: 100%;
  height: 80%;
  display: grid;
  grid-template-columns: 10% auto 10%;
  column-gap: 10px;
  overflow: hidden;
`;
const SidePanel = styled.div`
  height: 100%;
  display: grid;
  margin-top: 12px;
  grid-template-rows: repeat(6, 57px);
  // margin: 12px 0px;
`;
const MiddlePanel = styled.div`
  border: solid 10px rgba(197, 197, 190, 1);
  border-radius: 3%;
  max-height: ${MenuButtonSize.height * 6}px;
  // max-width: ${MenuButtonSize.width * 5}px;
`;

const M3SR: React.FunctionComponent<any> = (props) => {
  const [value, setValue] = useState(0);

  return (
    <CompContainer>
      <EventContext.Provider value={DefaultEventContext}>
        <>
          <ConsoleContainer>
            <TopPanel data-name="top-panel">
              <SidePanel>
                <MenuTouchableButton
                  buttonFor="1"
                  direction={MenuDirection.RIGHT}
                />
                <MenuTouchableButton
                  buttonFor="2"
                  direction={MenuDirection.RIGHT}
                />
                <MenuTouchableButton
                  buttonFor="3"
                  direction={MenuDirection.RIGHT}
                />
                <MenuTouchableButton
                  buttonFor="4"
                  direction={MenuDirection.RIGHT}
                />
                <MenuTouchableButton
                  buttonFor="5"
                  direction={MenuDirection.RIGHT}
                />
                <MenuTouchableButton
                  buttonFor="6"
                  direction={MenuDirection.RIGHT}
                />
              </SidePanel>
              <MiddlePanel data-name="middle-panel">
                <Console
                  menu={
                    MenuJson.map((item, index) => ({
                      ...item,
                      index: index + 1,
                    })) as Array<MenuItem>
                  }
                />
              </MiddlePanel>
              <SidePanel>
                <MenuTouchableButton
                  buttonFor="15"
                  direction={MenuDirection.LEFT}
                />
                <MenuTouchableButton
                  buttonFor="14"
                  direction={MenuDirection.LEFT}
                />
                <MenuTouchableButton
                  buttonFor="13"
                  direction={MenuDirection.LEFT}
                />
                <MenuTouchableButton
                  buttonFor="12"
                  direction={MenuDirection.LEFT}
                />
                <MenuTouchableButton
                  buttonFor="11"
                  direction={MenuDirection.LEFT}
                />
                <MenuTouchableButton
                  buttonFor="10"
                  direction={MenuDirection.LEFT}
                />
              </SidePanel>
            </TopPanel>
            <ButtonPanelContianer>
              <LeftButtonContainer>
                <BlackButton options={['ON', 'OFF']} />
                <BlackButton options={['MENU', 'HOME']} />
                <DoubleButton options={['ON', 'CU']} />
              </LeftButtonContainer>
              <MiddleButtonContainer>
                <MenuTouchableButton
                  buttonFor="7"
                  direction={MenuDirection.UP}
                />
                <MenuTouchableButton
                  buttonFor="8"
                  direction={MenuDirection.UP}
                />
                <MenuTouchableButton
                  buttonFor="9"
                  direction={MenuDirection.UP}
                />
              </MiddleButtonContainer>
              <RightButtonContainer>
                <DoubleButton options={['G', 'GO']} />
                <BlackButton options={['ESC', 'CLR']} />
                <BlackButton options={['ENT']} />
              </RightButtonContainer>
            </ButtonPanelContianer>
          </ConsoleContainer>
          <DialPadContainer>
            <DialPad>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, '+/-', 0, '.'].map((ele) => {
                return <NumberBox>{ele}</NumberBox>;
              })}
            </DialPad>
            <KnobContainer className="silver-knob">
              <Silver
                diameter={100}
                min={0}
                max={100}
                step={1}
                value={value}
                onValueChange={setValue}
              ></Silver>
            </KnobContainer>
          </DialPadContainer>
        </>
      </EventContext.Provider>
    </CompContainer>
  );
};

export default M3SR;
